/**
 * This file exists to contain functions involved in loading tsv filings into data structures
 */

import { loadFromTsv } from "./Tsv";
import * as CONSTANTS from "./constants";
import { Edge } from "./Edge";
import { EdgeData } from "./EdgeData";
import { NodeData } from "./NodeData";


/**
 * loads the NodeNetwork from NODES_TSV_FILE and saves it in @param {Storage} storage
 * @param {Storage} storage
 */
export async function loadNetwork(storage) {
    let nodesArray = await loadFromTsv(CONSTANTS.NODES_TSV_FILE, 7, function (row, lineNum) {
        return nodeRowTransformer(row, lineNum);
    });
    let names = nodesArray.map(node => {
        return node.getName();
    });
    storage.createNodes(names, nodesArray)

    let edges = await loadFromTsv(CONSTANTS.EDGES_TSV_FILE, 1, function(row, lineNum) {
        return edgeRowTransformer(row, lineNum);
    })
    storage.importEdges(edges);
}

/**
 * translates tsv file format to NodeData
 * @param {string} row from tsv file
 * @param {number} lineNum
 * @return {NodeData} NodeData
 */
function nodeRowTransformer(row, lineNum) {
    let name = row["DEVICE_ID"];
    let deviceType = null;
    let costShutoff = null;
    let costInfected = null;
    let costGoodwill = null;
    let lat = null;
    let long = null;
    if (name[0] === "S") {
        deviceType = CONSTANTS.SERVER;
    }
    else if (name[0] === "C") {
        deviceType = CONSTANTS.PC;
    }
    else if (name[0] === "D") {
        deviceType = CONSTANTS.SCADA;
    }
    else {
        throw new Error("invalid device name " + row["DEVICE_ID"] + " on line " + lineNum + " : must start with S, C, or D");
    }

    if (!Object.keys(CONSTANTS.NETWORK_TSV_GROUP_MAP).includes(row["GROUP_SUBNET"].toLowerCase())) {
        throw new Error("invalid group " + row["GROUP_SUBNET"] + " on line " + lineNum + "; valid choices: " + JSON.parse(Object.keys(CONSTANTS.NETWORK_TSV_GROUP_MAP)));    
    }
    let group = CONSTANTS.NETWORK_TSV_GROUP_MAP[row["GROUP_SUBNET"].toLowerCase()];

    let description = row["DEVICE_DESCRIPTION"];
    try {
        costShutoff = stripCurrencySyntax(row["COST_TO_SHUT_OFF"]);
    } catch (error) {
        throw new Error("invalid cost if infected " + row["COST_TO_SHUT_OFF"] + " on line " + lineNum + "; must consist of only numbers, commas, and dollar sign");
    }
    try {
        costInfected = stripCurrencySyntax(row["COST_IF_INFECTED"]);
    } catch (error) {
        throw new Error("invalid cost to shut down " + row["COST_IF_INFECTED"] + " on line " + lineNum + "; must consist of only numbers, commas, and dollar sign");
    }

    try {
        costGoodwill = stripCurrencySyntax(row["DISRUPTION_COST"]);
    } catch (error) {
        throw new Error("invalid goodwill cost " + row["DISRUPTION_COST"] + " on line " + lineNum + "; must consist of only numbers, commas, and dollar sign");
    }

    try {
        long = parseFloat(row["LONGITUDE"]);
    } catch (error) {
        throw new Error("invalid longitude " + row["LONGITUDE"] + " on line " + lineNum + "; must be a decimal number");
    }

    try {
        lat = parseFloat(row["LATITUDE"]);
    } catch (error) {
        throw new Error("invalid latitude " + row["LATITUDE"] + " on line " + lineNum + "; must be a decimal number");
    }
    let newNodeData = NodeData.build(name, group, CONSTANTS.HEALTHY, false, [], lat, long, costShutoff, costInfected, costGoodwill, deviceType, description);
    return newNodeData;
}

/** remove currency data from the string such as '$', ',' or '.' and returns it as a number
 * @param {string} str
 * @return {number} number
 */
function stripCurrencySyntax(str) {
    return parseFloat(str.replace(/\$/g, ""));
}

/**
 * convert edges rows in tsv file to Edges
 * @param {array} row
 * @param {number} lineNum
 * @return {Edge} Edge
 */
function edgeRowTransformer(row, lineNum) {
    let src = row["SOURCE_NODE"];
    let dst = row["DESTINATION_NODE"].replace("/\n/", "");
    return Edge.build(src, dst, EdgeData.build());
}